import React, { Component } from "react";
import { reactRouterBaseRoute } from "./../../../config";
import { withStyles } from "@material-ui/core/styles";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { loginWithCookie } from "./../../../state/actions/authActions";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = () => ({
  linearColorPrimary: {
    backgroundColor: "#b2dfdb",
  },
  linearBarColorPrimary: {
    backgroundColor: "#00695c",
  },
});

class AuthSession extends Component {
  componentDidMount() {
    this.props.loginWithCookie();
  }

  render() {
    const { classes } = this.props;
    // user is authenticated
    if (this.props.user.uid) {
      return (
        <Redirect
          to={{
            pathname: this.props.location.state.destination.substring(
              reactRouterBaseRoute.length + 1
            ),
          }}
        />
      );
    }

    // session could not be authenticated
    if (this.props.user.failedLogin === true) {
      return <Redirect to={{ pathname: "/login" }} />;
    }

    return (
      <LinearProgress
        classes={{
          colorPrimary: classes.linearColorPrimary,
          barColorPrimary: classes.linearBarColorPrimary,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({ user: state.auth });

const mapDispatchToProps = { loginWithCookie };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(AuthSession)));
